// Expo inlines EXPO_PUBLIC_* at build time (process.env reads only — no
// loadEnv() here; that's apps/api's pattern). Defaults target a local
// `bun run dev:api` on :7501 (see CLAUDE.md → Commands).
export const API_URL =
  process.env.EXPO_PUBLIC_API_URL ?? "http://localhost:7501";

export const APP_URL =
  process.env.EXPO_PUBLIC_APP_URL ??
  (typeof window !== "undefined"
    ? window.location.origin
    : "http://localhost:7500");

// The Astro marketing site (homepage + /compare affiliate hub). Result-page
// links (the equal-prominence compare hub, "how we make money") point here.
export const MARKETING_URL =
  process.env.EXPO_PUBLIC_MARKETING_URL ?? "https://www.moneybackaustralia.com";

// observa (Mode B). The browser/RN SDK posts to the shared hub; pass the bare
// origin — the SDK appends /_observability/trpc itself (resolveIngestUrl).
// Falls back to the API origin's mounted path when the hub var is unset. The
// public key (opk_) is safe to ship in the client bundle.
export const OBSERVA_ENDPOINT =
  process.env.EXPO_PUBLIC_OBSERVA_API_URL ?? `${API_URL}/_observability/trpc`;

export const OBSERVA_PUBLIC_KEY = process.env.EXPO_PUBLIC_OBSERVA_PUBLIC_KEY;
